import { TimeWindowsTitle } from 'components/BenchmarkStyles';

type Props = {
  isTimeWindowsScreen?: boolean;
  bechmarkCreated?: boolean;
};

export const TimeWindowsEditTitle = ({
  bechmarkCreated = true,
  isTimeWindowsScreen,
}: Props) => {
  if (!isTimeWindowsScreen || !bechmarkCreated) {
    return null;
  }

  return <TimeWindowsTitle>Edit Time Windows</TimeWindowsTitle>;
};
